<template src="./MessageHistory.html"></template>

<script>
import moment from "moment";
import { getMessages } from "../../../apiService/request/crudMendajes";
export default {
  data() {
    return {
      panel: "",
      documentPatient: 0,
      dataMessage: [],
      dialog: false,
      myLink: "",
      seeIframe: false,
      messageType: "",
    };
  },
  props: {
    dataTherapy: {
      type: Object,
      default: {},
    },
    infoPatient: {
      type: Array,
      default: [],
    },
  },
  created() {
    this.getPatientMessages();
  },
  methods: {
    activateDialog(i, link, typeMessage) {
      this.messageType = "";
      this.seeIframe = false;
      this.dialog = true;
      this.myLink = "";
      this.myLink = link;
      this.seeIframe = true;
      this.messageType = typeMessage;
    },
    async getPatientMessages() {
      this.$store.dispatch("setCargando", true);
      try {
        this.infoPatient.forEach((e) => {
          if (e.nombre === "Documento") {
            this.documentPatient = e.valor;
          }
        });
        const response = await getMessages(this.documentPatient, 100);
        if (response && response.data && response.data.data) {
          this.dataMessage = response.data.data;
        }
        if (response.data.data.length === 0) {
          alert("¡No existen mensajes enviados!");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
  },
  filters: {
    moment: function (date, format) {
      let fecha = isNaN(date) ? date : Number(date);
      return moment(fecha).format(format);
    },
  },
};
</script>

<style lang="scss" scoped src="./MessageHistory.scss">
</style>


// WEBPACK FOOTER //
// src/components/Mensajes/MessageHistory/MessageHistory.vue